import { Box, Grid, IconButton, Typography } from "@mui/material";
import FullScreenModal from "../../../../components/common/modalPopup/FullScreenModal";
import { pdfjs, Document, Page } from "react-pdf";
import { ClientInvoiceAgent } from "../../../../app/api/clientInvoices/ClientInvoiceAgent";
import { useEffect, useState } from "react";
import getAxiosError from "../../../../app/api/axiosError";
import { toast } from "react-toastify";
import {
  RootState,
  useAppDispatch,
} from "../../../../app/features/store/store";
import Loader from "../../../../components/common/loader/Loader";
import { RatecardClientInvoiceResponse } from "../../../../app/models/responseModels/ClientInvoiceResponses";
import DownloadIcon from "@mui/icons-material/Download";
// these css removes extra text and space displayed at the end of the pdf without disabling text selection
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { useSelector } from "react-redux";
import { RatecardFdpInvoiceResponse } from "../../../../app/models/responseModels/FdpInvoiceResponses";
import { FdpInvoiceAgent } from "../../../../app/api/fdpInvoices/FdpInvoiceAgent";
import FdpInvoiceActionMenu from "./FdpInvoiceActionMenu";
import ClientInvoiceComment from "../../../clients/invoices/modals/ClientInvoiceComment";
import FdpInvoiceComment from "./FdpInvoiceComment";

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   "pdfjs-dist/build/pdf.worker.min.mjs",
//   import.meta.url
// ).toString();

//pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
// pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';
//pdfjs.GlobalWorkerOptions.workerSrc = 'https://unpkg.com/pdfjs-dist@2.10.377/build/pdf.worker.min.js';
 //pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.min.mjs`;

interface FdpInvoicePreviewProps {
  isView: boolean,
  invoice: RatecardFdpInvoiceResponse | undefined;
  closeInvoicePreviewModal: CallableFunction;
  showInvoiceEditModal: CallableFunction;
}
const FdpInvoicePreviewModal = (props: FdpInvoicePreviewProps) => {
  const [numPages, setNumPages] = useState<number>();
  const [actionStatus, setActionStatus] = useState<string>("");
  const [file, setFile] = useState<any>();
  const [invoiceFileResponse, setInvoiceFileResponse] = useState<any>();
  const [invoiceResponse, setInvoiceResponse] =
    useState<RatecardFdpInvoiceResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [openNewCommentModal, setOpenNewCommentModal] =
    useState<boolean>(false);

  const handleSubmit = async () => {
    return true;
  };

  useEffect(() => {
    if (props.invoice) {
      setInvoiceResponse(props.invoice);
      fetchClientInvoiceFile(props.invoice?.id, props.invoice?.invoiceStatus);
    }
  }, []);

  const fetchClientInvoiceFile = async (
    invoicePkId: number,
    invoiceStatus: string
  ) => {
    try {
      setLoading(true);
      const response = await FdpInvoiceAgent.fetchFdpInvoiceFile(
        invoicePkId,
        invoiceStatus
      );
      setInvoiceFileResponse(response);
      setFile(new Blob([response?.data]));
    } catch (error) {
      toast.error("File isn't accessible.", {
        toastId: "FetchClientInvoiceFileException",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleActionWithComment = async (actionStatus: string) => {
    setActionStatus(actionStatus);
    setOpenNewCommentModal(!openNewCommentModal);
  };

  const handleAction = async (actionStatus: string) => {
    try {
      setLoading(true);
      if (props.invoice) {
        const response = await FdpInvoiceAgent.changeInvoiceStatus(
          props.invoice.id,
          actionStatus
        );
        if (response.isSuccess) {
          setInvoiceResponse(response.data);
          toast.success("FDP invoice Updated.", {
            toastId: "FDPInvoiceApprove",
          });
          props.closeInvoicePreviewModal();
        } else {
          toast.error("Failed to approve client invoice.", {
            toastId: "FdpInvoiceApproveException",
          });
        }
      }
    } catch (error) {
      const appError = getAxiosError(error);
      toast.error(`Failed to update FDP invoice - ${appError.errorMessage}`, {
        toastId: "FDPInvoiceApproveException",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <FullScreenModal
      title="Invoice Preview"
      updateAsyncOperation={handleSubmit}
      closeFullScreenModal={props.closeInvoicePreviewModal}
      isLoading={loading}
      closeModalAfterSubmit={true}
      confirmMessage="Are you sure you want to delete?"
      isUpdatePermission={true}
      isDeletePermission={false}
      showSubmitButton={false}
      showDeleteButton={false}
    >
      <Box>
        {loading ? (
          <Loader isLoading={loading} />
        ) : (
          <>
            <Grid container justifyContent={"space-between"}>
              <Grid item>
                <IconButton
                  type="button"
                  sx={{ marginRight: 2 }}
                  onClick={() => {
                    const fileName = invoiceFileResponse.headers["file-name"];
                    const url = window.URL.createObjectURL(
                      new Blob([invoiceFileResponse.data])
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                  }}
                >
                  <DownloadIcon sx={{ color: "primary.main" }} />
                </IconButton>
                <Box sx={{ width: "fit-content" }}>
                  {/* <Typography
                    p={0.5}
                    color={"white"}
                    fontWeight={"bold"}
                    sx={{ backgroundColor: "green" }}
                  >
                    Invoice Status: {invoiceResponse?.invoiceStatus}
                  </Typography> */}
                </Box>
              </Grid>
              <Grid item xs={8} sm={10} md={7} lg={7}>
                <FdpInvoiceComment
                  invoice={props.invoice}
                  actionStatus={actionStatus}
                  newCommentModal={openNewCommentModal}
                  closeNewCommentModal={() => setOpenNewCommentModal(false)}
                  handleAction={handleAction}
                />
              </Grid>
              <Grid item>
                <FdpInvoiceActionMenu
                  invoice={props.invoice}
                  handleAction={handleAction}
                  handleActionWithComment={handleActionWithComment}
                  handleEdit={() => {
                    props.showInvoiceEditModal();
                  }}
                  handleFlag={() =>
                    setOpenNewCommentModal(!openNewCommentModal)
                  }
                />
              </Grid>
            </Grid>
            <Box>
              <Document
                file={file}
                onLoadSuccess={({ numPages }: { numPages: number }) => {
                  setNumPages(numPages);
                }}
              >
                {Array.from(new Array(numPages), (_, index) => (
                  <>
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      width={Math.max(window.innerWidth * 0.95, 400)}

                      //   renderTextLayer={false}
                      //   renderAnnotationLayer={false}
                    />
                    <p>
                      Page {index + 1} of {numPages}
                    </p>
                  </>
                ))}
              </Document>
            </Box>
          </>
        )}
      </Box>
    </FullScreenModal>
  );
};

export default FdpInvoicePreviewModal;
